import React, { useState } from 'react';
import { 
  Globe, Cloud, Server, Database, Link, ExternalLink, 
  Code, FileText, Github, Shield, Key, Activity,
  Copy, Check, Search, Filter, Play, Loader2, CheckCircle, XCircle, AlertCircle
} from 'lucide-react';

const linksData = {
  production: {
    title: "🚀 Production Links",
    categories: [
      {
        name: "Cloudflare Pages (Live Sites)",
        icon: Globe,
        links: [
          { name: "Main Web App", url: "https://biig-web.pages.dev", description: "Main application portal" },
          { name: "Projects Directory", url: "https://biig-web.pages.dev/projects", description: "All projects in one place" },
          { name: "Problem Explorer", url: "https://biig-web.pages.dev/problems", description: "36 questions journey" },
          { name: "Question Links", url: "https://biig-web.pages.dev/questions", description: "Individual question experiences" },
          { name: "Single Question (Example)", url: "https://biig-web.pages.dev/problem/love_the_problem", description: "Example single question with music" },
          { name: "Location Pulse", url: "https://biig-web.pages.dev/share", description: "Share your location & activity" },
          { name: "Global Activity Map", url: "https://biig-web.pages.dev/global", description: "Real-time global activities" },
          { name: "Moderation Dashboard", url: "https://biig-web.pages.dev/moderate", description: "Review flagged activities" },
          { name: "Flywheel Dashboard", url: "https://biig-web.pages.dev/flywheel", description: "Business flywheel tracking" },
          { name: "Work Buttons", url: "https://biig-web.pages.dev/work", description: "Workplace automation" },
          { name: "CTO Dashboard", url: "https://biig-web.pages.dev/cto", description: "Tech operations dashboard" },
          { name: "Pousada Knolling", url: "https://biig-web.pages.dev/pousada", description: "Visual system overview - see everything at once" },
          { name: "Pousada Operations", url: "https://biig-web.pages.dev/pousada-ops", description: "Action-oriented operations dashboard" },
          { name: "Pousada Mobile", url: "https://biig-web.pages.dev/pousada-mobile", description: "Mobile-first thumb-friendly operations" },
          { name: "Pousada AI", url: "https://biig-web.pages.dev/pousada-ai", description: "AI-powered guest assistant" },
          { name: "CTO Tech Audit", url: "https://biig-web.pages.dev/cto/audit", description: "Technology audit checklist" },
          { name: "CTO Roadmap", url: "https://biig-web.pages.dev/cto/roadmap", description: "Implementation phases" },
          { name: "CTO Guest Experience", url: "https://biig-web.pages.dev/cto/guest", description: "Guest tech metrics" },
          { name: "CTO Operations", url: "https://biig-web.pages.dev/cto/operations", description: "Operational systems" },
          { name: "Color Palettes", url: "https://biig-web.pages.dev/colors", description: "Premium brand color schemes" },
          { name: "Research Links", url: "https://biig-web.pages.dev/research", description: "AI-powered link insights" },
          { name: "AI Connection Test", url: "https://biig-web.pages.dev/ai-connection-test", description: "Test Cloudflare AI bindings" },
          { name: "Dev Dashboard", url: "https://biig-web.pages.dev/dev", description: "Development tools and environment monitoring" },
        ]
      },
      {
        name: "Cloudflare Workers (APIs)",
        icon: Server,
        links: [
          { name: "Main API", url: "https://biig-api.b-9f2.workers.dev", description: "Primary API endpoint" },
          { name: "Health Check", url: "https://biig-api.b-9f2.workers.dev/api/health", description: "API status check" },
          { name: "Structure API", url: "https://biig-api.b-9f2.workers.dev/api/structure", description: "Project structure info" },
          { name: "Users API", url: "https://biig-api.b-9f2.workers.dev/api/users", description: "User management" },
          { name: "Projects API", url: "https://biig-api.b-9f2.workers.dev/api/projects", description: "Project management" },
          { name: "Problem Explorer API", url: "https://biig-api.b-9f2.workers.dev/api/problem-explorer", description: "Session & answer storage" },
          { name: "Flywheel API", url: "https://biig-api.b-9f2.workers.dev/api/flywheel", description: "Flywheel endpoints" },
          { name: "WhatsApp API", url: "https://biig-api.b-9f2.workers.dev/api/whatsapp", description: "WhatsApp messaging" },
          { name: "Telegram API", url: "https://biig-api.b-9f2.workers.dev/api/telegram", description: "Telegram bot integration" },
          { name: "Location API", url: "https://biig-api.b-9f2.workers.dev/api/location", description: "Location services" },
          { name: "Global Activities API", url: "https://biig-api.b-9f2.workers.dev/api/global", description: "Global activity tracking" },
          { name: "CTO Dashboard API", url: "https://biig-api.b-9f2.workers.dev/api/cto", description: "CTO dashboard endpoints" },
          { name: "Research Links API", url: "https://biig-api.b-9f2.workers.dev/api/research-links", description: "Research links endpoints" },
          { name: "AI Connection Test API", url: "https://biig-api.b-9f2.workers.dev/api/ai-connection-test/status", description: "AI testing endpoints" },
          { name: "AI Models API", url: "https://biig-api.b-9f2.workers.dev/api/ai", description: "AI model endpoints" },
          { name: "Phase 0 API", url: "https://biig-api.b-9f2.workers.dev/api/phase0", description: "Phase 0 implementation" },
          { name: "Phase 1 API", url: "https://biig-api.b-9f2.workers.dev/api/phase1", description: "Phase 1 implementation" },
          { name: "Hidden Gems API", url: "https://biig-api.b-9f2.workers.dev/api/hidden-gems", description: "Hidden gems discovery" },
          { name: "Pousada AI API", url: "https://biig-api.b-9f2.workers.dev/api/pousada", description: "Pousada AI services" },
          { name: "Adapters API", url: "https://biig-api.b-9f2.workers.dev/api/adapters", description: "System adapters" },
          { name: "Forge API", url: "https://biig-api.b-9f2.workers.dev/api/forge", description: "Brutal connection system" },
          { name: "Scraper API", url: "https://biig-api.b-9f2.workers.dev/api/scraper", description: "Web scraping service" },
          { name: "Dev Tools API", url: "https://biig-api.b-9f2.workers.dev/api/dev", description: "Development utilities" },
        ]
      },
      {
        name: "Recent Deployments",
        icon: Activity,
        links: [
          { name: "Latest Web Deploy", url: "https://0d1187b4.biig-web.pages.dev", description: "Most recent deployment" },
          { name: "Previous Deploy", url: "https://7a56b679.biig-web.pages.dev", description: "Previous stable version" },
          { name: "Music Update", url: "https://ec8ad286.biig-web.pages.dev", description: "With Infinitivo music" },
          { name: "Bilingual Update", url: "https://6b3f1286.biig-web.pages.dev", description: "PT-BR translation added" },
        ]
      }
    ]
  },
  development: {
    title: "🛠️ Development Links",
    categories: [
      {
        name: "Local Development",
        icon: Code,
        links: [
          { name: "Web App (Local)", url: "http://localhost:3001", description: "Local web development" },
          { name: "API (Local)", url: "http://localhost:8787", description: "Local API server" },
          { name: "Files Service (Local)", url: "http://localhost:8788", description: "Local file storage" },
          { name: "Email Service (Local)", url: "http://localhost:8789", description: "Local email service" },
          { name: "Docs Site (Local)", url: "http://localhost:3002", description: "Documentation site" },
          { name: "Work Buttons (Local)", url: "http://localhost:5174", description: "Work buttons app" },
          { name: "CTO Dashboard (Local)", url: "http://localhost:5173/cto", description: "CTO dashboard" },
          { name: "Pousada Knolling (Local)", url: "http://localhost:5173/pousada", description: "Visual system overview" },
          { name: "Pousada Operations (Local)", url: "http://localhost:5173/pousada-ops", description: "Operations dashboard" },
          { name: "Pousada Mobile (Local)", url: "http://localhost:5173/pousada-mobile", description: "Mobile operations" },
          { name: "Pousada AI (Local)", url: "http://localhost:5173/pousada-ai", description: "AI assistant" },
          { name: "CTO Tech Audit (Local)", url: "http://localhost:5173/cto/audit", description: "Tech audit" },
          { name: "CTO Roadmap (Local)", url: "http://localhost:5173/cto/roadmap", description: "Implementation roadmap" },
          { name: "Color Palettes (Local)", url: "http://localhost:5173/colors", description: "Premium color schemes" },
          { name: "Research Links (Local)", url: "http://localhost:5173/research", description: "AI-powered link insights" },
          { name: "AI Connection Test (Local)", url: "http://localhost:5173/ai-connection-test", description: "Test Cloudflare AI bindings" },
          { name: "Dev Dashboard (Local)", url: "http://localhost:5173/dev", description: "Dev tools and monitoring" },
        ]
      },
      {
        name: "Webhooks & Integrations",
        icon: Link,
        links: [
          { name: "Instagram Webhook", url: "https://biig-api.b-9f2.workers.dev/api/flywheel/webhooks/instagram", description: "Instagram message handler" },
          { name: "WhatsApp Webhook", url: "https://biig-api.b-9f2.workers.dev/api/flywheel/webhooks/whatsapp", description: "WhatsApp message handler" },
          { name: "Telegram Webhook", url: "https://biig-api.b-9f2.workers.dev/api/telegram/webhook", description: "Telegram bot webhook" },
        ]
      }
    ]
  },
  infrastructure: {
    title: "🏗️ Infrastructure",
    categories: [
      {
        name: "Cloudflare Resources",
        icon: Cloud,
        links: [
          { name: "D1 Database", url: "biig-biz-db", description: "SQLite database (ID: f8b7063f-c940-47e4-82b9-afa7fb75f14f)" },
          { name: "KV Namespace", url: "CACHE", description: "Key-value storage (ID: e4ed006f200f4298b2a42c6b35e8a081)" },
          { name: "R2 Bucket", url: "cf-storage", description: "Object storage bucket" },
          { name: "Workers AI", url: "AI Binding", description: "AI model access" },
        ]
      },
      {
        name: "Environment Variables",
        icon: Key,
        links: [
          { name: "TELEGRAM_BOT_TOKEN", url: "Secret", description: "Telegram bot authentication" },
          { name: "WHATSAPP_TOKEN", url: "Secret", description: "WhatsApp API token" },
          { name: "WHATSAPP_PHONE_ID", url: "Secret", description: "WhatsApp phone number ID" },
          { name: "OPENAI_API_KEY", url: "Secret", description: "OpenAI API access" },
          { name: "ANTHROPIC_API_KEY", url: "Secret", description: "Anthropic Claude API" },
        ]
      }
    ]
  },
  documentation: {
    title: "📚 Documentation",
    categories: [
      {
        name: "External Services",
        icon: ExternalLink,
        links: [
          { name: "Cloudflare Dashboard", url: "https://dash.cloudflare.com", description: "Manage workers & pages" },
          { name: "GitHub Repository", url: "https://github.com/biig-tech/biig-biz", description: "Source code (if public)" },
          { name: "WhatsApp Business", url: "https://business.facebook.com", description: "WhatsApp configuration" },
          { name: "Telegram BotFather", url: "https://t.me/botfather", description: "Telegram bot management" },
          { name: "OpenAI Platform", url: "https://platform.openai.com", description: "OpenAI API management" },
          { name: "Anthropic Console", url: "https://console.anthropic.com", description: "Claude API management" },
        ]
      },
      {
        name: "API Documentation",
        icon: Shield,
        links: [
          { name: "API Structure", url: "https://biig-api.b-9f2.workers.dev/api/structure?format=compact", description: "Compact project structure" },
          { name: "Health Status", url: "https://biig-api.b-9f2.workers.dev/api/health", description: "Check API health" },
          { name: "AI Connection Status", url: "https://biig-api.b-9f2.workers.dev/api/ai-connection-test/status", description: "Test AI bindings" },
        ]
      }
    ]
  }
};

interface TestResult {
  url: string;
  status: 'pending' | 'testing' | 'success' | 'error' | 'skipped';
  statusCode?: number;
  statusText?: string;
  contentSample?: string;
  error?: string;
  responseTime?: number;
  failureCategory?: string;
  failureReason?: string;
  suggestedFix?: string;
  isExpected?: boolean;
  skipReason?: string;
}

interface FailureAnalysis {
  category: string;
  reason: string;
  fix?: string;
  isExpected: boolean;
  color: string;
  displayName: string;
}

export default function BiigLinks() {
  const [copiedUrl, setCopiedUrl] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [testResults, setTestResults] = useState<Map<string, TestResult>>(new Map());
  const [isTestRunning, setIsTestRunning] = useState(false);
  const [showTestResults, setShowTestResults] = useState(false);

  const copyToClipboard = (url: string) => {
    navigator.clipboard.writeText(url);
    setCopiedUrl(url);
    setTimeout(() => setCopiedUrl(null), 2000);
  };

  const copyFailedLinks = () => {
    const failedLinks = Array.from(testResults.entries())
      .filter(([_, result]) => result.status === 'error')
      .map(([url, result]) => `${url} - ${result.error || `${result.statusCode} ${result.statusText}`}`)
      .join('\n');
    
    navigator.clipboard.writeText(failedLinks);
    setCopiedUrl('failed-links');
    setTimeout(() => setCopiedUrl(null), 2000);
  };

  const getFailedLinks = () => {
    return Array.from(testResults.entries())
      .filter(([_, result]) => result.status === 'error')
      .map(([url, result]) => ({ url, result }));
  };

  const analyzeFailure = (url: string, error?: string, statusCode?: number): FailureAnalysis => {
    // External sites that will always fail CORS
    const externalSites = [
      'dash.cloudflare.com',
      'github.com',
      'business.facebook.com',
      't.me',
      'platform.openai.com',
      'console.anthropic.com'
    ];
    
    // Check if it's an external site
    if (externalSites.some(site => url.includes(site))) {
      return {
        category: 'external_site',
        displayName: 'External',
        reason: 'External website - not testable from browser',
        fix: 'Working as expected - click link to visit directly',
        isExpected: true,
        color: 'blue'
      };
    }
    
    // Localhost URLs - these are impossible to test from deployed app
    if (url.includes('localhost')) {
      return {
        category: 'localhost',
        displayName: 'Localhost',
        reason: 'Cannot test localhost from deployed app',
        fix: 'These URLs only work when running locally on your machine',
        isExpected: true,
        color: 'gray'
      };
    }
    
    // API root CORS
    if (url === 'https://biig-api.b-9f2.workers.dev') {
      return {
        category: 'api_config',
        displayName: 'API Config',
        reason: 'API root needs index handler',
        fix: 'Add GET handler for root path',
        isExpected: false,
        color: 'orange'
      };
    }
    
    // 404 errors on API routes
    if (statusCode === 404 && url.includes('biig-api')) {
      // Check if it's a route that exists but has no root handler
      const routesWithNoRoot = [
        'problem-explorer', 'flywheel', 'whatsapp', 'telegram',
        'location', 'global', 'cto', 'dev', 'ai', 'phase0',
        'phase1', 'hidden-gems', 'pousada', 'forge', 'scraper'
      ];
      
      const route = routesWithNoRoot.find(r => url.includes(`/api/${r}`));
      if (route) {
        return {
          category: 'missing_handler',
          displayName: 'No Root Handler',
          reason: `Route /api/${route} exists but has no GET handler at root`,
          fix: `Add GET handler or use specific endpoints like /api/${route}/[action]`,
          isExpected: false,
          color: 'red'
        };
      }
    }
    
    // 500 errors
    if (statusCode === 500) {
      return {
        category: 'server_error',
        displayName: 'Server Error',
        reason: 'Internal server error - check logs',
        fix: 'Review server logs and database configuration',
        isExpected: false,
        color: 'red'
      };
    }
    
    // CORS errors on our own API
    if (error?.includes('CORS') && url.includes('biig-api')) {
      return {
        category: 'api_cors',
        displayName: 'API CORS',
        reason: 'CORS configuration issue',
        fix: 'Check CORS middleware configuration',
        isExpected: false,
        color: 'orange'
      };
    }
    
    // Default unknown error
    return {
      category: 'unknown',
      displayName: 'Unknown',
      reason: error || 'Unknown error',
      fix: 'Investigate further',
      isExpected: false,
      color: 'gray'
    };
  };

  const testUrl = async (url: string): Promise<TestResult> => {
    const startTime = Date.now();
    
    try {
      // Skip localhost URLs entirely - they're impossible to test from deployed app
      if (url.includes('localhost') || url.includes('127.0.0.1')) {
        return {
          url,
          status: 'skipped',
          skipReason: 'Localhost URLs cannot be tested from deployed app',
          failureCategory: 'localhost',
          isExpected: true
        };
      }
      
      // For non-HTTP URLs, just mark as not testable
      if (!url.startsWith('http')) {
        return {
          url,
          status: 'skipped',
          skipReason: 'Internal resource identifier',
          failureCategory: 'internal',
          isExpected: true
        };
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        signal: controller.signal,
        headers: {
          'Accept': 'text/html,application/json,text/plain,*/*'
        }
      });

      clearTimeout(timeoutId);
      const responseTime = Date.now() - startTime;

      let contentSample = '';
      const contentType = response.headers.get('content-type');
      
      if (contentType?.includes('application/json')) {
        const json = await response.json();
        contentSample = JSON.stringify(json, null, 2).substring(0, 200) + '...';
      } else if (contentType?.includes('text/')) {
        const text = await response.text();
        // Try to extract meaningful content from HTML
        if (contentType.includes('text/html')) {
          // Remove script and style tags
          const cleanText = text
            .replace(/<script[^>]*>.*?<\/script>/gis, '')
            .replace(/<style[^>]*>.*?<\/style>/gis, '')
            .replace(/<[^>]+>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
          contentSample = cleanText.substring(0, 200) + '...';
        } else {
          contentSample = text.substring(0, 200) + '...';
        }
      } else {
        contentSample = `Binary content (${contentType})`;
      }

      if (!response.ok) {
        const analysis = analyzeFailure(url, `${response.status} ${response.statusText}`, response.status);
        
        return {
          url,
          status: 'error',
          statusCode: response.status,
          statusText: response.statusText,
          responseTime,
          failureCategory: analysis.category,
          failureReason: analysis.reason,
          suggestedFix: analysis.fix,
          isExpected: analysis.isExpected
        };
      }
      
      return {
        url,
        status: 'success',
        statusCode: response.status,
        statusText: response.statusText,
        contentSample,
        responseTime
      };
    } catch (error) {
      const responseTime = Date.now() - startTime;
      
      let errorMessage = 'Unknown error';
      
      if (error instanceof Error) {
        if (error.name === 'AbortError') {
          errorMessage = 'Request timeout (10s)';
        } else if (error.message.includes('Failed to fetch')) {
          errorMessage = 'CORS blocked or network error';
        } else {
          errorMessage = error.message;
        }
      }
      
      const analysis = analyzeFailure(url, errorMessage);
      
      return {
        url,
        status: 'error',
        error: errorMessage,
        responseTime,
        failureCategory: analysis.category,
        failureReason: analysis.reason,
        suggestedFix: analysis.fix,
        isExpected: analysis.isExpected
      };
    }
  };

  const runUrlTests = async () => {
    setIsTestRunning(true);
    setShowTestResults(true);
    const results = new Map<string, TestResult>();

    // Collect all URLs and categorize them
    const urlsToTest: string[] = [];
    const urlsToSkip: string[] = [];
    
    filteredLinks.forEach(section => {
      section.categories.forEach(category => {
        category.links.forEach(link => {
          if (link.url.includes('localhost') || link.url.includes('127.0.0.1')) {
            urlsToSkip.push(link.url);
            // Mark localhost URLs as skipped immediately
            results.set(link.url, {
              url: link.url,
              status: 'skipped',
              skipReason: 'Localhost URLs cannot be tested from deployed app',
              failureCategory: 'localhost',
              isExpected: true
            });
          } else if (link.url.startsWith('http')) {
            urlsToTest.push(link.url);
            // Set initial pending status
            results.set(link.url, {
              url: link.url,
              status: 'pending'
            });
          }
        });
      });
    });

    setTestResults(new Map(results));

    // Test URLs in batches to avoid overwhelming the browser
    const batchSize = 5;
    for (let i = 0; i < urlsToTest.length; i += batchSize) {
      const batch = urlsToTest.slice(i, i + batchSize);
      
      // Update status to testing for this batch
      batch.forEach(url => {
        results.set(url, { ...results.get(url)!, status: 'testing' });
      });
      setTestResults(new Map(results));

      // Test batch in parallel
      const batchResults = await Promise.all(
        batch.map(url => testUrl(url))
      );

      // Update results
      batchResults.forEach(result => {
        results.set(result.url, result);
      });
      setTestResults(new Map(results));
    }

    setIsTestRunning(false);
  };

  const allCategories = Object.values(linksData).flatMap(section => 
    section.categories.map(cat => cat.name)
  );

  const filteredLinks = Object.entries(linksData).map(([key, section]) => ({
    ...section,
    categories: section.categories
      .filter(category => selectedCategory === 'all' || category.name === selectedCategory)
      .map(category => ({
        ...category,
        links: category.links.filter(link => 
          searchTerm === '' || 
          link.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          link.url.toLowerCase().includes(searchTerm.toLowerCase()) ||
          link.description.toLowerCase().includes(searchTerm.toLowerCase())
        )
      }))
      .filter(category => category.links.length > 0)
  })).filter(section => section.categories.length > 0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Biig Links Reference
          </h1>
          <p className="text-gray-400 text-lg">
            All workers, pages, APIs, and endpoints in one place
          </p>
        </div>

        {/* Search and Filter */}
        <div className="mb-8 flex flex-col md:flex-row gap-4">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-3 text-gray-400" size={20} />
            <input
              type="text"
              placeholder="Search links, URLs, or descriptions..."
              className="w-full pl-10 pr-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:border-blue-500 focus:outline-none"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="relative">
            <Filter className="absolute left-3 top-3 text-gray-400" size={20} />
            <select
              className="pl-10 pr-8 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:border-blue-500 focus:outline-none appearance-none cursor-pointer"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="all">All Categories</option>
              {[...new Set(allCategories)].map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>
          <button
            onClick={runUrlTests}
            disabled={isTestRunning}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 rounded-lg text-white font-medium flex items-center gap-2 transition-colors"
          >
            {isTestRunning ? (
              <>
                <Loader2 className="animate-spin" size={20} />
                Testing URLs...
              </>
            ) : (
              <>
                <Play size={20} />
                Test All URLs
              </>
            )}
          </button>
        </div>

        {/* Test Results Summary */}
        {showTestResults && (
          <div className="mb-8 space-y-4">
            {/* Summary Panel */}
            <div className="p-4 bg-gray-800 border border-gray-700 rounded-lg">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-white">URL Test Results</h3>
                <button
                  onClick={() => setShowTestResults(false)}
                  className="text-gray-400 hover:text-white"
                >
                  ✕
                </button>
              </div>
              
              {testResults.size > 0 && (
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-4">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-green-400">
                      {Array.from(testResults.values()).filter(r => r.status === 'success').length}
                    </div>
                    <div className="text-sm text-gray-400">Working</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-red-400">
                      {Array.from(testResults.values()).filter(r => r.status === 'error' && !r.isExpected).length}
                    </div>
                    <div className="text-sm text-gray-400">Need Fix</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-400">
                      {Array.from(testResults.values()).filter(r => r.status === 'error' && r.isExpected).length}
                    </div>
                    <div className="text-sm text-gray-400">External</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-gray-400">
                      {Array.from(testResults.values()).filter(r => r.status === 'skipped').length}
                    </div>
                    <div className="text-sm text-gray-400">Impossible</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-yellow-400">
                      {Array.from(testResults.values()).filter(r => r.status === 'testing' || r.status === 'pending').length}
                    </div>
                    <div className="text-sm text-gray-400">In Progress</div>
                  </div>
                </div>
              )}

              <div className="text-sm text-gray-400">
                {isTestRunning ? 'Testing in progress...' : 'Test complete'}
              </div>
            </div>

            {/* Failure Categories Summary */}
            {!isTestRunning && getFailedLinks().length > 0 && (
              <div className="p-4 bg-gray-800 border border-gray-700 rounded-lg">
                <h3 className="text-lg font-semibold text-white mb-3">Failure Analysis Summary</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {(() => {
                    const categories = new Map<string, { count: number; expected: boolean; displayName: string }>();
                    getFailedLinks().forEach(({ result }) => {
                      const cat = result.failureCategory || 'unknown';
                      if (!categories.has(cat)) {
                        categories.set(cat, { 
                          count: 0, 
                          expected: result.isExpected || false,
                          displayName: cat.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
                        });
                      }
                      categories.get(cat)!.count++;
                    });
                    
                    return Array.from(categories.entries()).map(([key, data]) => (
                      <div key={key} className="bg-gray-900 rounded-lg p-3">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-300">
                            {data.displayName}
                          </span>
                          <span className={`text-lg font-bold ${
                            data.expected ? 'text-blue-400' : 'text-red-400'
                          }`}>
                            {data.count}
                          </span>
                        </div>
                        <div className="text-xs text-gray-500 mt-1">
                          {data.expected ? 'Expected' : 'Needs Fix'}
                        </div>
                      </div>
                    ));
                  })()}
                </div>
                <div className="mt-4 text-xs text-gray-500">
                  💡 Tip: Focus on fixing "Needs Fix" items. Expected failures are normal behavior.
                </div>
              </div>
            )}

            {/* Localhost Warning */}
            {Array.from(testResults.values()).some(r => r.status === 'skipped' && r.failureCategory === 'localhost') && (
              <div className="p-4 bg-yellow-900/20 border border-yellow-800/50 rounded-lg">
                <div className="flex items-start gap-3">
                  <AlertCircle className="text-yellow-400 mt-0.5 flex-shrink-0" size={20} />
                  <div>
                    <h3 className="text-lg font-semibold text-yellow-400">Localhost URLs Not Testable</h3>
                    <p className="text-sm text-gray-400 mt-1">
                      {Array.from(testResults.values()).filter(r => r.failureCategory === 'localhost').length} localhost URLs were skipped. 
                      These can only be tested when running the app locally on your machine.
                    </p>
                    <p className="text-xs text-gray-500 mt-2">
                      💡 Tip: Port numbers may vary based on what's available when starting local servers.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Unreachable Links Panel - separate actual failures from external sites */}
            {getFailedLinks().filter(({result}) => result.status !== 'skipped' && !result.isExpected).length > 0 && (
              <div className="p-4 bg-red-900/20 border border-red-800/50 rounded-lg">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-lg font-semibold text-red-400">Links Needing Attention</h3>
                    <p className="text-sm text-gray-400 mt-1">
                      {getFailedLinks().filter(({result}) => !result.isExpected && result.status !== 'skipped').length} issue{getFailedLinks().filter(({result}) => !result.isExpected && result.status !== 'skipped').length !== 1 ? 's' : ''} found
                    </p>
                  </div>
                  <button
                    onClick={copyFailedLinks}
                    className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg text-white text-sm font-medium flex items-center gap-2 transition-colors"
                  >
                    {copiedUrl === 'failed-links' ? (
                      <>
                        <Check size={16} />
                        Copied!
                      </>
                    ) : (
                      <>
                        <Copy size={16} />
                        Copy All Failed
                      </>
                    )}
                  </button>
                </div>
                
                <div className="space-y-2 max-h-64 overflow-y-auto">
                  {getFailedLinks().filter(({result}) => result.status !== 'skipped' && !result.isExpected).map(({ url, result }) => (
                    <div key={url} className="flex items-start gap-3 p-3 bg-gray-800/50 rounded-lg group">
                      <XCircle className="text-red-400 mt-0.5 flex-shrink-0" size={18} />
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <span className="text-sm text-white font-mono break-all">
                            {url}
                          </span>
                          <button
                            onClick={() => copyToClipboard(url)}
                            className="opacity-0 group-hover:opacity-100 text-gray-400 hover:text-white transition-opacity flex-shrink-0"
                            title="Copy URL"
                          >
                            {copiedUrl === url ? (
                              <Check size={14} className="text-green-400" />
                            ) : (
                              <Copy size={14} />
                            )}
                          </button>
                        </div>
                        <div className="flex items-start gap-2 mt-1">
                          <div className="flex-1">
                            <div className="text-xs text-red-400">
                              {result.error || `${result.statusCode} ${result.statusText}`}
                            </div>
                            {result.failureReason && (
                              <div className="text-xs text-gray-400 mt-1">
                                💡 {result.failureReason}
                              </div>
                            )}
                            {result.suggestedFix && !result.isExpected && (
                              <div className="text-xs text-green-400 mt-1">
                                ✅ Fix: {result.suggestedFix}
                              </div>
                            )}
                            {result.responseTime && (
                              <div className="text-xs text-gray-500 mt-1">
                                Response time: {result.responseTime}ms
                              </div>
                            )}
                          </div>
                          {result.failureCategory && (
                            <span className={`text-xs px-2 py-1 rounded-full ${
                              result.isExpected ? 'bg-blue-900/50 text-blue-400' : 'bg-red-900/50 text-red-400'
                            }`}>
                              {result.failureCategory === 'external_site' && 'External'}
                              {result.failureCategory === 'localhost' && 'Local'}
                              {result.failureCategory === 'missing_handler' && 'No Handler'}
                              {result.failureCategory === 'server_error' && '500'}
                              {result.failureCategory === 'api_config' && 'Config'}
                              {result.failureCategory === 'api_cors' && 'CORS'}
                              {result.failureCategory === 'unknown' && 'Unknown'}
                              {result.isExpected && ' ✓'}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* External Sites Panel */}
            {getFailedLinks().filter(({result}) => result.failureCategory === 'external_site').length > 0 && (
              <div className="p-4 bg-blue-900/20 border border-blue-800/50 rounded-lg">
                <div className="flex items-start gap-3">
                  <ExternalLink className="text-blue-400 mt-0.5 flex-shrink-0" size={20} />
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-blue-400">External Websites</h3>
                    <p className="text-sm text-gray-400 mt-1">
                      {getFailedLinks().filter(({result}) => result.failureCategory === 'external_site').length} external site{getFailedLinks().filter(({result}) => result.failureCategory === 'external_site').length !== 1 ? 's' : ''} detected
                    </p>
                    <p className="text-xs text-gray-500 mt-2">
                      💡 These are working correctly. Browser security prevents testing external sites from our domain. Click the links to visit them directly.
                    </p>
                    <div className="mt-3 flex flex-wrap gap-2">
                      {getFailedLinks().filter(({result}) => result.failureCategory === 'external_site').map(({url}) => (
                        <a
                          key={url}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-1 px-3 py-1 bg-blue-800/30 hover:bg-blue-800/50 rounded-full text-xs text-blue-300 transition-colors"
                        >
                          {new URL(url).hostname.replace('www.', '')}
                          <ExternalLink size={10} />
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Links Sections */}
        {filteredLinks.map((section, sectionIdx) => (
          <div key={sectionIdx} className="mb-12">
            <h2 className="text-2xl font-bold mb-6 text-gray-100">
              {section.title}
            </h2>
            
            {section.categories.map((category, catIdx) => {
              const IconComponent = category.icon;
              return (
                <div key={catIdx} className="mb-8">
                  <div className="flex items-center gap-3 mb-4">
                    <IconComponent className="text-blue-400" size={24} />
                    <h3 className="text-xl font-semibold text-gray-200">
                      {category.name}
                    </h3>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {category.links.map((link, linkIdx) => (
                      <div
                        key={linkIdx}
                        className="bg-gray-800 border border-gray-700 rounded-lg p-4 hover:border-blue-500 transition-all group"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="font-medium text-white group-hover:text-blue-400 transition-colors">
                            {link.name}
                          </h4>
                          <button
                            onClick={() => copyToClipboard(link.url)}
                            className="text-gray-400 hover:text-blue-400 transition-colors"
                            title="Copy URL"
                          >
                            {copiedUrl === link.url ? (
                              <Check size={16} className="text-green-400" />
                            ) : (
                              <Copy size={16} />
                            )}
                          </button>
                        </div>
                        
                        <p className="text-sm text-gray-400 mb-2">
                          {link.description}
                        </p>
                        
                        <div className="flex items-center gap-2">
                          {link.url.startsWith('http') ? (
                            <a
                              href={link.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-xs text-blue-400 hover:text-blue-300 break-all flex items-center gap-1"
                            >
                              {link.url}
                              <ExternalLink size={12} />
                            </a>
                          ) : (
                            <span className="text-xs text-gray-500 font-mono">
                              {link.url}
                            </span>
                          )}
                          
                          {/* Test Status Indicator */}
                          {testResults.has(link.url) && (
                            <div className="ml-auto flex items-center gap-1">
                              {testResults.get(link.url)?.status === 'pending' && (
                                <span title="Pending test">
                                  <AlertCircle size={14} className="text-gray-500" />
                                </span>
                              )}
                              {testResults.get(link.url)?.status === 'testing' && (
                                <span title="Testing...">
                                  <Loader2 size={14} className="text-yellow-400 animate-spin" />
                                </span>
                              )}
                              {testResults.get(link.url)?.status === 'success' && (
                                <span title={`Success: ${testResults.get(link.url)?.statusCode}`}>
                                  <CheckCircle size={14} className="text-green-400" />
                                </span>
                              )}
                              {testResults.get(link.url)?.status === 'error' && (
                                <span title={`Error: ${testResults.get(link.url)?.error || testResults.get(link.url)?.statusCode}`}>
                                  <XCircle size={14} className="text-red-400" />
                                </span>
                              )}
                              {testResults.get(link.url)?.status === 'skipped' && (
                                <span title={testResults.get(link.url)?.skipReason}>
                                  <AlertCircle size={14} className="text-gray-400" />
                                </span>
                              )}
                              
                              {testResults.get(link.url)?.responseTime && (
                                <span className="text-xs text-gray-500">
                                  {testResults.get(link.url)?.responseTime}ms
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                        
                        {/* Test Result Details */}
                        {testResults.has(link.url) && showTestResults && (
                          <div className="mt-3 pt-3 border-t border-gray-700">
                            {testResults.get(link.url)?.status === 'success' && (
                              <div className="space-y-1">
                                <div className="text-xs text-green-400">
                                  ✓ {testResults.get(link.url)?.statusCode} {testResults.get(link.url)?.statusText}
                                </div>
                                {testResults.get(link.url)?.contentSample && (
                                  <div className="text-xs text-gray-500 font-mono bg-gray-900 p-2 rounded overflow-x-auto">
                                    {testResults.get(link.url)?.contentSample}
                                  </div>
                                )}
                              </div>
                            )}
                            {testResults.get(link.url)?.status === 'error' && (
                              <div className="text-xs text-red-400">
                                ✗ {testResults.get(link.url)?.error || `${testResults.get(link.url)?.statusCode} ${testResults.get(link.url)?.statusText}`}
                              </div>
                            )}
                            {testResults.get(link.url)?.status === 'skipped' && (
                              <div className="text-xs text-gray-400">
                                ⊘ {testResults.get(link.url)?.skipReason}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        ))}

        {/* Stats */}
        <div className="mt-12 pt-8 border-t border-gray-700 text-center">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-gray-800 rounded-lg p-4">
              <div className="text-2xl font-bold text-blue-400">10+</div>
              <div className="text-sm text-gray-400">Pages Sites</div>
            </div>
            <div className="bg-gray-800 rounded-lg p-4">
              <div className="text-2xl font-bold text-green-400">9+</div>
              <div className="text-sm text-gray-400">Worker APIs</div>
            </div>
            <div className="bg-gray-800 rounded-lg p-4">
              <div className="text-2xl font-bold text-purple-400">4+</div>
              <div className="text-sm text-gray-400">Databases</div>
            </div>
            <div className="bg-gray-800 rounded-lg p-4">
              <div className="text-2xl font-bold text-orange-400">50+</div>
              <div className="text-sm text-gray-400">Total Endpoints</div>
            </div>
          </div>
          
          <p className="text-gray-500 text-sm">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
}